import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Contact from "@/pages/Contact";
import OrderTracking from "@/pages/OrderTracking";
import Admin from "@/pages/Admin";
import { CGV, MentionsLegales, Confidentialite } from "@/pages/Legal";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/boutique" element={<Catalog />} />
              <Route path="/produit/:slug" element={<ProductDetail />} />
              <Route path="/paiement" element={<Checkout />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/connexion" element={<Login />} />
              <Route path="/inscription" element={<Register />} />
              <Route path="/compte" element={<Account />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/suivi-commande" element={<OrderTracking />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/cgv" element={<CGV />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/confidentialite" element={<Confidentialite />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#120E1A",
              border: "1px solid rgba(255,107,0,0.3)",
              color: "#F5F0EB",
            },
          }}
        />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
